import { CREATE_TERM, CREATING_TERM, GET_TERMS, GETTING_TERMS, TERMS_ERROR, UPDATE_TERM, UPDATING_TERM } from "../types"

const initialState = {
    terms: [],
    loadingTerms: true,
    termsError: null,
    creatingTerm: false,
    createdTerm: null,
    updatingTerm: false,
    updatedTerm: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_TERMS:
        return {
            ...state,
            loadingTerms :action.payload,
        }
        case GET_TERMS:
        return{
            ...state,
            loadingTerms:false,
            termsError:  null,
            terms: action.payload,
        }
        case UPDATING_TERM:
        return {
            ...state,
            updatingTerm: action.payload,
        }
        case UPDATE_TERM:
        return{
            ...state,
            updatingTerm:false,
            termsError: null,
            updatedTerm: action.payload,
        }
        case CREATING_TERM:
        return {
            ...state,
            creatingTerm: action.payload,
        }
        case CREATE_TERM:
        return{
            ...state,
            creatingTerm:false,
            termsError: null,
            createdTerm: action.payload,
        }
        case TERMS_ERROR:
        return{
            ...state,
            loadingTerms:false,
            updatingTerm: false,
            // creatingApplication:false,
            termsError: action.payload 
        }
        default: return state
    }

}